import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const Recaptcha = ({recaptchaRef}) => {
  return (
    <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_SITE_KEY} />
  )
}

export default Recaptcha